module.exports = __webpack_public_path__ + "static/media/goods11.1e726a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods11.png
// module id = 436
// module chunks = 0